type EnvConfig = {
  urlApi: string;
};

export const appConfig = (window as any).globalConfig as EnvConfig || { urlApi: process.env.REACT_APP_URL_API}   
